import { Fragment, useEffect, useState } from 'react';
import './SubscriptionPlan.css';
import AdminSubscriberService from '../../../API/Services/AdminService/AdminSubscriberService';
import AdminPaymentService from '../../../API/Services/AdminService/AdminPaymentService';
import ClipLoader from 'react-spinners/ClipLoader';
import PriceComponent from '../../components/Price/PriceComponent';
import swal from "sweetalert";
import { useNavigate } from 'react-router-dom';
import DateComponent from '../../components/date/DateFormat';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { MultiSelect } from 'react-multi-select-component';
import MainPagetitle from '../../layouts/MainPagetitle';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PaymentOffcanvas from '../Payment/PaymentOffcanvas';
import { isValidSubscriptionStatus, updateStoredSubscriptionAccess, safeJsonParse } from '../../../utils/subscriptionAccess';

const stripePromise = loadStripe(process.env.REACT_APP_PK_KEY);

const SubscriptionPlan = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingCard, setIsLoadingCard] = useState(false);
    const [activePlan, setActivePlan] = useState(localStorage.getItem("subscriptionActivePlan") ? localStorage.getItem("subscriptionActivePlan") : false);

    const [isSubscribed, setIsSubscribed] = useState(localStorage.getItem("is_subscribed") ? JSON.parse(localStorage.getItem("is_subscribed")) : "");
    const [subscriptionPlanList, setSubscriptionPlanList] = useState([]);
    const [subscriptionDataTypeList, setSubscriptionDataTypeList] = useState([]);
    const [activeSubscriptionPlan, setActiveSubscriptionPlan] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [numberOfSeat, setNumberOfSeat] = useState("");
    const [numberOfSeatLimit, setNumberOfSeatLimit] = useState("");
    const [totalNumberOfSeat, setTotalNumberOfSeat] = useState("");
    const [pricePerSeatUpTo, setPricePerSeatUpTo] = useState("");
    const [pricePerSeatAbove, setPricePerSeatAbove] = useState("");
    const [baseSeats, setBaseSeats] = useState("");
    const [dataTypeLimit, setDataTypeLimit] = useState("");
    const [dataTypeLimitMessage, setDataTypeLimitMessage] = useState("");
    const [planID, setPlanID] = useState("");
    const [planFrequency, setPlanFreQuency] = useState('monthly');
    const [planPriceData, setPlanPriceData] = useState("");
    const [couponCode, setCouponCode] = useState("");
    const [sucessMsg, setSucessMsg] = useState("");
    const [actualPriceData, setActualPriceData] = useState("");
    const [errMsg, setErrMsg] = useState("");
    const [isApply, setIsApply] = useState(false);
    const [isConfirming, setIsConfirming] = useState(false);
    const [isSelect, setIsSelect] = useState(false);
    const [originalPriceData, setOriginalPriceData] = useState("");
    const [isAcknowledged, setIsAcknowledged] = useState(false);

    const [cardList, setCardList] = useState([]);
    const [selectedCard, setSelectedCard] = useState("");
    const [canvasShowAdd, setCanvasShowAdd] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("usertoken")) {
            GetSubscriptionPlanList();
            GetSubscriptionPlanDataType();
            GetActivePlanDetails();
        } else {
            navigate("/");
        }
    }, []);

    useEffect(() => {
        if (dataTypeLimitMessage) setDataTypeLimitMessage("");
    }, [dataTypeLimit]);

    useEffect(() => {
        if (showModal) {
            GetCardList();
        }
    }, [showModal]);

    const GetSubscriptionPlanList = async () => {
        setIsLoading(true);
        try {
            const responseData = await AdminSubscriberService.getSubscriptionPlanList().json();
            if (responseData.status === true) {
                setSubscriptionPlanList(responseData.data);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            if (error.name === "HTTPError") {
            }
        }
    };

    const GetCardList = async () => {
        setIsLoadingCard(true);
        try {
            const responseData = await AdminPaymentService.index().json();
            if (responseData.cards && responseData.cards.length > 0) {
                setIsLoadingCard(false);
                setCardList(responseData.cards);

                if (responseData.cards.length > 0) {
                    if (responseData.cards.length === 1) {
                        setSelectedCard(responseData.cards[0].id);
                    } else {
                        const defaultCard = responseData.cards.find(card => card.is_default == true);
                        if (defaultCard) {
                            setSelectedCard(defaultCard.id);
                        } else {
                            setSelectedCard(responseData.cards[0].id);
                        }
                    }
                }
            }
        } catch (error) {
            setIsLoadingCard(false);
            console.error("Error fetching cards", error);
        }
    };

    const GetSubscriptionPlanDataType = async () => {
        setIsLoading(true);
        try {
            const responseData = await AdminSubscriberService.getSubscriptionDataType().json();
            if (responseData.status === true) {
                const subscriptionDataTypeList = responseData.data.map(item => ({
                    label: item.title,
                    value: item.id
                }));
                setSubscriptionDataTypeList(subscriptionDataTypeList);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            if (error.name === "HTTPError") {
            }
        }
    };

    const GetActivePlanDetails = async () => {
        setIsLoading(true);
        let backendMessage = "No Active Subscription found";
        try {
            const responseData = await AdminSubscriberService.getActiveSubscriptionPlan().json();
            if (responseData.status === true && responseData.data) {
                setActiveSubscriptionPlan(responseData.data);
                setNumberOfSeatLimit(responseData.data.subscription?.login_limit || responseData.data.total_seat);
                setTotalNumberOfSeat(responseData.data.total_seat);
                setActivePlan(true);
                updateStoredSubscriptionAccess(responseData.data);
                setIsSubscribed(isValidSubscriptionStatus(responseData.data.subscription_status) ? 1 : 0);
                setIsLoading(false);
                return;
            } else if (responseData?.message) {
                backendMessage = responseData.message;
            }
        } catch (error) {
            console.error("Error fetching active subscription", error);
        }

        // Fallback: check if the user has an active or scheduled subscription in subscriber list
        try {
            const rawUser = localStorage.getItem("user");
            const user = safeJsonParse(rawUser);
            const userEmail = user?.email;

            if (userEmail) {
                const subscriberRes = await AdminSubscriberService.getSubscriberList({ search: userEmail }).json();
                if (subscriberRes?.status === true && Array.isArray(subscriberRes.data) && subscriberRes.data.length > 0) {
                    const matchedSub = subscriberRes.data.find(sub => {
                        const emailMatch = String(sub.user_email || "").toLowerCase() === userEmail.toLowerCase() ||
                            (Array.isArray(sub.user) && sub.user.some(u => String(u.email || "").toLowerCase() === userEmail.toLowerCase()));
                        const expiry = sub.subscription_end_at || sub.subscription_cancelled_at;
                        const notExpired = expiry && new Date(expiry).getTime() > Date.now();
                        const isPaid = String(sub.payment_status || "").toLowerCase() === "paid";
                        return emailMatch && notExpired && isPaid;
                    });

                    if (matchedSub) {
                        const expiry = matchedSub.subscription_end_at || matchedSub.subscription_cancelled_at;
                        const normalizedSub = {
                            id: matchedSub.id,
                            payment_status: matchedSub.payment_status,
                            subscription_status: "scheduled_for_cancellation",
                            is_scheduled_for_cancellation: true,
                            subscription_ref: matchedSub.subscription_ref || "",
                            subscription_start_at: matchedSub.subscription_start_at,
                            subscription_end_at: expiry,
                            subscription_cancelled_at: matchedSub.subscription_cancelled_at,
                            cancellation_requested_at: matchedSub.cancellation_requested_at || matchedSub.subscription_start_at,
                            price: matchedSub.price || matchedSub.subscription_price,
                            total_price: matchedSub.price || matchedSub.subscription_price,
                            total_seat: matchedSub.total_seats || 2,
                            subscription: {
                                id: matchedSub.subscription_id,
                                title: matchedSub.subscription_title,
                                type: matchedSub.subscription_type,
                                login_limit: matchedSub.total_seats,
                                data_type_limit: matchedSub.data_type_limit,
                                content: matchedSub.subscription_content,
                            },
                            subscription_data_types: matchedSub.data_types || [],
                        };

                        setActiveSubscriptionPlan(normalizedSub);
                        setNumberOfSeatLimit(normalizedSub.subscription.login_limit);
                        setTotalNumberOfSeat(normalizedSub.total_seat);
                        setActivePlan(true);
                        updateStoredSubscriptionAccess(normalizedSub);
                        setIsSubscribed(1);
                        setIsLoading(false);
                        return;
                    }
                }
            }
        } catch (fallbackError) {
            console.error("Fallback subscriber check error", fallbackError);
        }

        setActivePlan(false);
        setActiveSubscriptionPlan({});
        localStorage.removeItem("subscriptionActivePlan");
        localStorage.setItem("is_subscribed", 0);
        localStorage.removeItem("subscription_data_types");
        localStorage.removeItem("subscription_end_at");

        const rawUser = localStorage.getItem("user");
        try {
            const user = JSON.parse(rawUser);
            if (user) {
                localStorage.setItem("user", JSON.stringify({ ...user, is_subscribed: 0 }));
            }
        } catch (e) {
            // ignore parse error
        }

        if (typeof window !== "undefined") {
            window.dispatchEvent(new Event("subscriptionAccessUpdated"));
        }

        setIsSubscribed(0);
        setIsLoading(false);
        swal(backendMessage || "No Active Subscription found");
    };

    const handleUpgradeClick = (id, login_limit, data_type_limit, price_per_seat_upto, price_per_seat_above, base_seats, planPrice, planTitle) => {
        swal({
            title: "Are you sure?",
            text: "Your previous plan will be cancelled, and the new upgraded plan will be activated immediately.",
            icon: "warning",
            buttons: {
                cancel: "Cancel",
                confirm: {
                    text: "Yes, Upgrade",
                    value: true,
                },
            },
            dangerMode: true,
        }).then((willUpgrade) => {
            if (willUpgrade) {
                handleSubcriptionPlan(id, login_limit, data_type_limit, price_per_seat_upto, price_per_seat_above, base_seats, planPrice, planTitle);
            }
        });
        setActualPriceData("");
        setPlanPriceData("");
        setSucessMsg("");
        setCouponCode("");
        setErrMsg("");
        setIsSelect(false);
        setPlanFreQuency("monthly");
    };

    const handleSubcriptionPlan = (id, login_limit, data_type_limit, price_per_seat_upto, price_per_seat_above, base_seats, planPrice, planTitle) => {
        setShowModal(!showModal);
        setPlanID(id);
        setPricePerSeatUpTo(price_per_seat_upto);
        setPricePerSeatAbove(price_per_seat_above);
        setBaseSeats(base_seats);
        setNumberOfSeatLimit(login_limit);
        setDataTypeLimit(data_type_limit);
        handleNumberofSeatChange(login_limit);
        setOriginalPriceData(planPrice);
        setPlanFreQuency("monthly");
        setSucessMsg("");
        setCouponCode("");
        setErrMsg("");
        setActualPriceData("");
        setPlanPriceData("");
        setIsSelect(false);
        setIsAcknowledged(false);

        if (planTitle && planTitle.toLowerCase() == "enterprise") {
            setSelectedOptions(subscriptionDataTypeList);
        } else {
            setSelectedOptions([]);
        }
    };

    const handleSubscribeConfirm = async () => {
        if (!selectedOptions || selectedOptions.length < dataTypeLimit) {
            setDataTypeLimitMessage(`Please select at least ${dataTypeLimit} data type(s).`);
            return;
        }

        if (!selectedCard) {
            swal("Please select a payment method.");
            return;
        }

        setIsLoading(true);
        setIsConfirming(true);
        try {
            let DataType = selectedOptions.map(option => String(option.value))
            var userData = {
                payment_period: planFrequency,
                plan_id: planID,
                seats: numberOfSeat,
                data_types: DataType,
                coupon_code: couponCode,
                payment_method: selectedCard
            }
            const responseData = await AdminSubscriberService.subscribPaln(userData).json();
            if (responseData.status === true) {
                swal(responseData.message).then((willClose) => {
                    if (willClose) {
                        localStorage.clear();
                        navigate("/login");
                    }
                });
                setIsLoading(false);
                setIsConfirming(false);
            } else {
                swal(responseData.message).then((willDelete) => {
                    if (willDelete) {
                        GetSubscriptionPlanList();
                    }
                });
                setIsLoading(false);
                setIsConfirming(false);
            }
        } catch (error) {
            setIsLoading(false);
            setIsConfirming(false);
            if (error.name === "HTTPError") {
            }
        }
    };

    const handleApplyCoupon = async () => {
        try {
            setIsApply(true);
            const payload = {
                coupon_code: couponCode,
                amount: planFrequency === "monthly" ? originalPriceData : originalPriceData * 11
            }

            const responseData = await AdminSubscriberService.applyCoupon(payload).json();

            if (responseData?.status) {
                setIsApply(false);
                setPlanPriceData(responseData?.final_amount)
                setActualPriceData(responseData?.original_amount)
                setIsSelect(true);
                setErrMsg("");
                setSucessMsg("Coupon applied sucessfully!")
            } else {
                setIsApply(false);
                setErrMsg(responseData?.message)
                setSucessMsg("")
            }
        } catch (error) {
            setIsApply(false);
            console.log("err", error);
        }
    };

    const handleBack = () => {
        navigate("/subscriptionlist");
    };

    const HandleUpgradeSeats = (currentSeats) => {
        let tempSeats = currentSeats;

        swal({
            title: "Upgrade Seats",
            content: {
                element: "div",
                attributes: {
                    innerHTML: `
                      <div style="text-align:center;">
                        <p style="margin-bottom:4px;">Manage your seats</p>
                        <div class="seat-box">
                          <button id="decBtn" class="seat-btn disabled">−</button>
                          <span id="seatCount" class="seat-count">${tempSeats}</span>
                          <button id="incBtn" class="seat-btn">+</button>
                        </div>
                        <div class="info-text">
                          Minimum seats: ${currentSeats}
                        </div>
                        <div id="extraSeats" class="extra-text" style="display:none;">
                          Extra seats: +0
                        </div>
                      </div>
                    `,
                },
            },
            buttons: {
                cancel: "Cancel",
                confirm: {
                    text: "Confirm",
                    className: "confirm-btn-hidden"
                },
            },
        }).then((willConfirm) => {
            if (willConfirm && tempSeats > currentSeats) {
                UpdateSeatCount(tempSeats, currentSeats);
            }
        });

        const style = document.createElement('style');
        style.innerHTML = '.confirm-btn-hidden { display: none !important; }';
        document.head.appendChild(style);

        setTimeout(() => {
            const seatCountEl = document.getElementById("seatCount");
            const incBtn = document.getElementById("incBtn");
            const decBtn = document.getElementById("decBtn");
            const extraSeatsEl = document.getElementById("extraSeats");
            const swalConfirmBtn = document.querySelector(".swal-button--confirm");

            const updateExtraSeats = () => {
                const extra = tempSeats - currentSeats;
                if (extra > 0) {
                    extraSeatsEl.style.display = "block";
                    extraSeatsEl.innerText = `Extra seats: +${extra}`;
                    decBtn.classList.remove("disabled");
                    swalConfirmBtn.classList.remove("confirm-btn-hidden");
                } else {
                    extraSeatsEl.style.display = "none";
                    decBtn.classList.add("disabled");
                    swalConfirmBtn.classList.add("confirm-btn-hidden");
                }
            };

            incBtn.onclick = () => {
                tempSeats++;
                seatCountEl.innerText = tempSeats;
                updateExtraSeats();
            };

            decBtn.onclick = () => {
                if (tempSeats > currentSeats) {
                    tempSeats--;
                    seatCountEl.innerText = tempSeats;
                    updateExtraSeats();
                }
            };
        }, 0);
    };

    const UpdateSeatCount = async (seats, currentSeats) => {
        setIsLoading(true);
        try {
            const extraSeats = seats - currentSeats;
            var userData = {
                extra_seats: extraSeats
            }
            const responseData = await AdminSubscriberService.seat_upgrade(userData).json();
            if (responseData.status === true) {
                window.location.href = responseData.url;
                setIsLoading(false);
            } else {
                swal(responseData.message).then((willDelete) => {
                    if (willDelete) {
                        GetSubscriptionPlanList();
                        GetActivePlanDetails();
                        setIsLoading(false);
                    }
                });
            }
        } catch (error) {
            setIsLoading(false);
        }
    };

    const HandleCancelSubscription = async (Id) => {
        swal({
            title: "Cancel Subscription?",
            text: "Your subscription will remain active until the end of your current paid billing period. Automatic renewal will be disabled and no further charges will occur.",
            icon: "warning",
            buttons: ["Keep Subscription", "Schedule Cancellation"],
            dangerMode: true,
        }).then(async (willCancel) => {
            if (willCancel) {
                setIsLoading(true);
                try {
                    const response = await AdminSubscriberService.subscribCancel(Id);
                    const responseData = await response.json();
                    if (responseData.status === true) {
                        swal({
                            title: "Cancellation Scheduled",
                            text: responseData.message || "Your subscription has been scheduled for cancellation at the end of the billing period.",
                            icon: "success",
                        }).then(() => {
                            setIsLoading(false);
                            GetSubscriptionPlanList();
                            GetActivePlanDetails();
                        });
                    } else {
                        swal({
                            title: "Error",
                            text: responseData.message || "Unable to schedule cancellation.",
                            icon: "error",
                        }).then(() => {
                            setIsLoading(false);
                            GetSubscriptionPlanList();
                        });
                    }
                } catch (error) {
                    setIsLoading(false);
                    if (error.name === "HTTPError") {
                    }
                }
            }
        });
    };

    const handleSelectDataTypeChange = (selectedItems) => {
        if (selectedItems.length > dataTypeLimit) {
            setDataTypeLimitMessage(`You can only select up to ${dataTypeLimit} data type(s).`);
            return;
        } else {
            setSelectedOptions(selectedItems);
            setDataTypeLimitMessage("");
        }
    };

    const handleNumberofSeatChange = (seat) => {
        const min = Number(numberOfSeatLimit);
        const numericValue = Number(seat);

        if (seat === "") {
            setNumberOfSeat(min);
            return;
        }
        setNumberOfSeat(numericValue < min ? min : numericValue);
    };

    const handleFrequencyChange = (e) => {
        setPlanFreQuency(e.target.value);
    };

    const parentCallback = () => {
        GetCardList();
        setShowModal(true);
    };

    const isFutureCancellation = Boolean(
        activeSubscriptionPlan?.subscription_cancelled_at &&
        new Date(activeSubscriptionPlan.subscription_cancelled_at).getTime() > Date.now()
    );

    const isScheduledForCancellation = Boolean(
        activeSubscriptionPlan?.subscription_status === "scheduled_for_cancellation" ||
        activeSubscriptionPlan?.is_scheduled_for_cancellation ||
        activeSubscriptionPlan?.cancellation_requested_at ||
        isFutureCancellation
    );

    return (
        <Fragment>
            {isSubscribed == 1 && <MainPagetitle mainTitle="Subscription Plan" pageTitle="Subscription Plan" parentTitle="Subscription List" link={`/subscriptionlist`} />}

            <div className="subscription-container">
                {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center mb-5">
                        <ClipLoader color="#4474fc" />
                    </div>
                ) : (
                    <>
                        <h1 className="main-title">Choose Your Subscription Plan</h1>

                        {activePlan && (isValidSubscriptionStatus(activeSubscriptionPlan?.subscription_status) || isScheduledForCancellation) && (
                            <div className={`active-plan-banner ${isScheduledForCancellation ? 'scheduled-cancellation-banner' : ''}`}>
                                {isScheduledForCancellation && (
                                    <div className="scheduled-notice-box">
                                        <div className="d-flex align-items-center gap-2">
                                            <i className="fa-solid fa-triangle-exclamation"></i>
                                            <div>
                                                <strong>Scheduled for Cancellation:</strong> Automatic renewal has been disabled. You continue to have full access to all subscribed modules and features until your subscription expiration date.
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="banner-body">
                                    <div className="banner-content">
                                        <div className="info-group">
                                            <div className="info-item">
                                                <span className="label">Current Plan</span>
                                                <span className="value highlighting">{activeSubscriptionPlan?.subscription?.title} Plan</span>
                                            </div>

                                            {isScheduledForCancellation ? (
                                                <>
                                                    <div className="info-item">
                                                        <span className="label">Cancellation Request Date</span>
                                                        <span className="value highlighting">
                                                            <DateComponent date={activeSubscriptionPlan.cancellation_requested_at || activeSubscriptionPlan.subscription_start_at} subscribPaln={true} />
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="label">Subscription Expiration Date</span>
                                                        <span className="value highlighting">
                                                            <DateComponent date={activeSubscriptionPlan.subscription_end_at || activeSubscriptionPlan.subscription_cancelled_at} subscribPaln={true} />
                                                        </span>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="info-item">
                                                    <span className="label">Renewal Date</span>
                                                    <span className="value highlighting">
                                                        <DateComponent date={activeSubscriptionPlan.subscription_end_at} subscribPaln={true} />
                                                    </span>
                                                </div>
                                            )}

                                            <div className="info-item">
                                                <span className="label">Usage Limits</span>
                                                <span className="value highlighting">{totalNumberOfSeat ? totalNumberOfSeat : activeSubscriptionPlan.subscription.login_limit} Seats | {activeSubscriptionPlan.subscription.data_type_limit} Data Types</span>
                                            </div>
                                        </div>

                                        <div className="info-item data-types-full-width">
                                            <span className="label">Active Data Types</span>
                                            <span className="value highlighting small-text">
                                                {activeSubscriptionPlan.subscription_data_types?.map(i => i.title).join(", ") || "NA"}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="subscription-actions">
                                        {isScheduledForCancellation ? (
                                            <div className="cancellation-status-widget">
                                                <div className="widget-header">
                                                    <span className="widget-kicker">SUBSCRIPTION STATUS</span>
                                                    <div className="scheduled-status-pill">
                                                        <span className="status-dot-pulse"></span>
                                                        Scheduled for Cancellation
                                                    </div>
                                                </div>

                                                <div className="widget-details">
                                                    <div className="widget-row">
                                                        <span className="widget-label">
                                                            <i className="fa-solid fa-ban text-danger me-1"></i> Auto-Renewal
                                                        </span>
                                                        <span className="widget-val text-danger fw-bold">Disabled</span>
                                                    </div>
                                                    <div className="widget-row">
                                                        <span className="widget-label">
                                                            <i className="fa-regular fa-calendar-check text-warning me-1"></i> Full Access Until
                                                        </span>
                                                        <span className="widget-val fw-bold text-dark">
                                                            <DateComponent date={activeSubscriptionPlan.subscription_end_at || activeSubscriptionPlan.subscription_cancelled_at} subscribPaln={true} />
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="widget-footer">
                                                    <i className="fa-solid fa-circle-check text-success me-1"></i>
                                                    <span>All modules remain active</span>
                                                </div>
                                            </div>
                                        ) : (
                                            activeSubscriptionPlan.subscription_cancelled_at == null && isValidSubscriptionStatus(activeSubscriptionPlan.subscription_status) && (
                                                <>
                                                    <button
                                                        className="sub-btn upgrade-btn"
                                                        onClick={() => HandleUpgradeSeats(totalNumberOfSeat ? totalNumberOfSeat : numberOfSeatLimit)}
                                                    >
                                                        Upgrade Seats
                                                    </button>

                                                    <button
                                                        className="sub-btn cancel-btn"
                                                        onClick={() => HandleCancelSubscription(activeSubscriptionPlan?.id)}
                                                    >
                                                        Cancel Subscription
                                                    </button>
                                                </>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="card-grid">
                            {subscriptionPlanList?.map((data) => {
                                const currentActiveId = activeSubscriptionPlan?.subscription?.id;
                                const currentActivePrice = parseFloat(activeSubscriptionPlan?.subscription?.price || 0);
                                const isCurrentPlan = activePlan && data.id === currentActiveId;
                                const isLowerTier = activePlan && parseFloat(data.price) < currentActivePrice;
                                const isDisabled = isCurrentPlan || isLowerTier;

                                return (
                                    <div key={data.id} className={`plan-card ${isCurrentPlan ? 'active' : ''} ${isCurrentPlan && isScheduledForCancellation ? 'scheduled-card' : ''} ${isLowerTier ? 'disabled' : ''}`}>
                                        {isCurrentPlan && (
                                            <div className={`badge-current ${isScheduledForCancellation ? 'badge-scheduled' : ''}`}>
                                                {isScheduledForCancellation ? (
                                                    <>
                                                        <i className="fa-solid fa-clock-rotate-left me-1"></i>
                                                        Scheduled to End
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fa-solid fa-check me-1"></i>
                                                        Active Plan
                                                    </>
                                                )}
                                            </div>
                                        )}
                                        <h3>{data.title}</h3>
                                        <div className="pricing">
                                            <span className="amount"><PriceComponent price={data.price} /></span>
                                            <span className="period">/month</span>
                                        </div>
                                        <div className="yearly-pricing">Or <PriceComponent price={data.price * 11} />/year</div>

                                        <ul className="feature-list">
                                            {data.content.split(',').map((item, i) => (
                                                <li key={i}><i className="fa-solid fa-circle-check"></i> {item.trim()}</li>
                                            ))}
                                        </ul>

                                        <button
                                            className="plan-btn"
                                            disabled={isDisabled}
                                            onClick={() => {
                                                const isUpgrade = activePlan && activeSubscriptionPlan?.subscription && !isCurrentPlan && !isLowerTier;

                                                if (isUpgrade) {
                                                    handleUpgradeClick(data.id, data.login_limit, data.data_type_limit, data.price_per_seat_below_base_seat, data.price_per_seat_above_base_seat, data.base_seat, data?.price, data.title);
                                                } else {
                                                    handleSubcriptionPlan(data.id, data.login_limit, data.data_type_limit, data.price_per_seat_below_base_seat, data.price_per_seat_above_base_seat, data.base_seat, data?.price, data.title);
                                                }
                                            }}
                                        >
                                            {
                                                !activePlan || !activeSubscriptionPlan?.subscription ? "Subscribe" :
                                                    isCurrentPlan ? (isScheduledForCancellation ? "Scheduled to End" : "Current Plan") :
                                                        isLowerTier ? "Locked" : "Upgrade Plan"
                                            }
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                        {activeSubscriptionPlan?.subscription_status != "pending" && (isSubscribed == 1 || activeSubscriptionPlan?.id != null || activePlan) &&
                            <div style={{ marginTop: "30px", display: "flex", justifyContent: "center" }}>
                                <button className="btn btn-primary btn-sm me-1" onClick={() => handleBack()}>
                                    Go Back
                                </button>
                            </div>
                        }
                    </>
                )}
            </div>

            {/* Modal */}
            {showModal &&
                <Modal show={showModal} onHide={() => setShowModal(true)} scrollable centered dialogClassName="custom-modal-width">
                    <Modal.Header>
                        <Modal.Title>Choose Data Types & Payment</Modal.Title>
                        <button
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setShowModal(false)}
                        ></button>
                    </Modal.Header>
                    <Modal.Body>
                        {dataTypeLimitMessage && <div style={{ color: "red", padding: "5px" }}>{dataTypeLimitMessage}</div>}
                        <div className="row">
                            <div className="notes-warning mb-3">
                                <div className="d-flex align-items-start">
                                    <i className="bi bi-exclamation-triangle-fill me-2 warning-icon"></i>
                                    <div>
                                        <ul className="mb-0 ps-3">
                                            <li>The price per seat is <strong><PriceComponent price={pricePerSeatUpTo} /></strong> for up to <strong style={{ color: "black" }}>{baseSeats || 0} </strong><strong>seats</strong>.</li>
                                            <li>The price per seat is <strong><PriceComponent price={pricePerSeatAbove} /></strong> for <strong>above <strong style={{ color: "black" }}>{baseSeats || 0} </strong>seats</strong>.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 mt-3">
                                <div className="d-flex align-items-center">
                                    <label className="form-label mb-0 me-2 fw-semibold">
                                        Subscription price:
                                    </label>
                                    <span className="fw-bold text-primary">

                                        {planPriceData
                                            ? `$${planPriceData}`
                                            : `$${planFrequency === "monthly"
                                                ? originalPriceData
                                                : originalPriceData * 11}`}
                                    </span>
                                </div>
                            </div>

                            {actualPriceData && (
                                <div className="col-12 mt-1">
                                    <div className="d-flex align-items-center">
                                        <label className="form-label mb-0 me-2 fw-semibold text-muted">
                                            Original price:
                                        </label>
                                        <span className="fw-bold text-secondary">
                                            ${actualPriceData}
                                        </span>
                                    </div>
                                </div>
                            )}


                            {actualPriceData && (
                                <div className="col-12 mt-1">
                                    <div className="d-flex align-items-center">
                                        <label className="form-label mb-0 me-2 fw-semibold text-muted">
                                            Coupon discount:
                                        </label>
                                        <span className="fw-bold text-secondary">
                                            ${actualPriceData - planPriceData}
                                        </span>
                                    </div>
                                </div>
                            )}

                            <div className="col-md-6 mt-3 w-100">
                                <div className='d-flex justify-content-start'>
                                    <div className='me-5'>
                                        <label className="form-label me-3">Monthly</label>
                                        <input
                                            type="radio"
                                            value="monthly"
                                            disabled={isSelect}
                                            name="plan_frequency"
                                            defaultChecked={true}
                                            onChange={handleFrequencyChange}
                                        />
                                    </div>
                                    <div>
                                        <label className="form-label me-3">Yearly</label>
                                        <input
                                            type="radio"
                                            value="yearly"
                                            disabled={isSelect}
                                            name="plan_frequency"
                                            onChange={handleFrequencyChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mt-3 w-100">
                                <label className="form-label">Number of Seat: <span className="text-danger">*</span></label>
                                <input
                                    type="number"
                                    value={numberOfSeat}
                                    name="number_of_seat"
                                    className="form-control"
                                    min={numberOfSeatLimit}
                                    onChange={(e) => handleNumberofSeatChange(e.target.value)}
                                    onKeyDown={(e) => ["e", "E", "+", "-", "."].includes(e.key) && (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()}
                                    onWheel={(e) => e.currentTarget.blur()}
                                />
                            </div>
                            <div className="col-md-6 mt-3 w-100">
                                <label className="form-label">Select Data Type: <span className="text-danger">*</span></label>
                                <MultiSelect
                                    name="data_type"
                                    options={subscriptionDataTypeList}
                                    value={selectedOptions}
                                    onChange={handleSelectDataTypeChange}
                                    isOptionDisabled={() => selectedOptions.length >= dataTypeLimit}
                                    placeholder="Select data types..."
                                />
                            </div>

                            <div className="col-md-12 mt-3">
                                <label className="form-label">Payment Method: <span className="text-danger">*</span></label>
                                <div className="d-flex gap-2">
                                    <select
                                        className="form-control"
                                        value={selectedCard}
                                        onChange={(e) => setSelectedCard(e.target.value)}
                                    >
                                        <option value="">Select Card</option>
                                        {cardList.length > 0 ? (
                                            cardList.map((card, index) => (
                                                <option key={index} value={card.id}>
                                                    {card.brand ? card.brand.toUpperCase() : "CARD"} **** {card.last4}
                                                    {card.is_default == true ? " (Default)" : ""}
                                                </option>
                                            ))
                                        ) : (
                                            <option value="" disabled>No cards found</option>
                                        )}
                                    </select>
                                    <button
                                        className="btn btn-outline-primary"
                                        style={{ whiteSpace: "nowrap" }}
                                        onClick={() => {
                                            setCanvasShowAdd(true);
                                            setShowModal(false);
                                        }}
                                    >
                                        <i className="fa-solid fa-plus me-1"></i> Add Card
                                    </button>
                                </div>
                            </div>

                            <div className="col-md-6 mt-3 w-100">
                                <div className="d-flex align-items-center gap-3 mt-2">
                                    <label
                                        className="form-label mb-0"
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        Apply coupon:
                                    </label>

                                    <input
                                        type="text"
                                        name="couponcode"
                                        value={couponCode}
                                        className="form-control"
                                        onChange={(e) => {
                                            const value = e.target.value
                                                .toUpperCase()
                                                .replace(/[^A-Z0-9]/g, "");

                                            setCouponCode(value);
                                        }}
                                        style={{ maxWidth: "200px" }}
                                    />
                                    <Button disabled={!couponCode || isApply} variant="primary" onClick={handleApplyCoupon}>
                                        {isApply ? "Applying..." : "Apply"}
                                    </Button>
                                </div>
                                {sucessMsg && <p className="text-success fs-12 mt-4">{sucessMsg}</p>}
                                {errMsg && <p className="text-danger fs-12 mt-1">{errMsg}</p>}
                            </div>

                            <div className="col-12 mt-3">
                                <div className="notes-warning mb-0">
                                    <div className="d-flex align-items-center">
                                        <input
                                            className="form-check-input me-2"
                                            type="checkbox"
                                            id="autoRenewAck"
                                            checked={isAcknowledged}
                                            onChange={(e) => setIsAcknowledged(e.target.checked)}
                                            style={{ marginTop: 0, cursor: 'pointer', borderColor: '#e5a36b' }}
                                        />
                                        <label className="fw-bold form-check-label mb-0" htmlFor="autoRenewAck" style={{ cursor: 'pointer' }}>
                                            I acknowledge that my subscription will auto-renew until cancelled. <span className="text-danger">*</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(!showModal)}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleSubscribeConfirm} disabled={isConfirming || !isAcknowledged}>
                            {isConfirming ? "Confirming..." : "Confirm Subscription"}
                        </Button>
                    </Modal.Footer>
                </Modal>
            }

            <Elements stripe={stripePromise}>
                <PaymentOffcanvas
                    canvasShowAdd={canvasShowAdd}
                    seCanvasShowAdd={setCanvasShowAdd}
                    Title="Add New Card"
                    parentCallback={parentCallback}
                />
            </Elements>
        </Fragment>
    );
};

export default SubscriptionPlan;
